import { autoinject, bindable, customAttribute } from 'aurelia-framework';
import { HtmlDrag, IDraggableHandler } from "./models";

@autoinject
@customAttribute("html-draggable")
export class Draggable extends HtmlDrag {
	@bindable handler: IDraggableHandler;
	@bindable model: any;

	constructor(private element: Element) {
		super();
	}	

	attached() {
		this.bindDragEvents(this.element);
		this.element.setAttribute("draggable", "true");
	}

	onDragStart(event: any): void {
		this.handler.onDragStart(event, this.model);
	}

	onDragEnd(event: any): void {
		this.handler.onDragEnd(event, this.model);
	}
}
